// SendFeedback.styles.ts
import styled from "styled-components";

// ===== INTERFACE DO TEMA =====
interface Theme {
  colors: {
    background: string;
    text: string;
    selection: string;
    modalColor: string;
    border: string;
    primary?: string;
    danger?: string;
    selectionDark?: string;
    textOnPrimary?: string;
    label?: string;
    borderColor?: string;
  };
}

// ===== COMPONENTES UTILIZADOS NO SENDFEEDBACK =====
export const FieldsContainer = styled.div`
  width: 100%;
  max-width: 100%;
  height: 85%;
  max-height: 85%;
  padding: var(--sp-24);
  flex-direction: column;
  box-sizing: border-box;
  overflow: auto;

  &::-webkit-scrollbar {
    width: calc(var(--u) * 15);
    height: calc(var(--u) * 15);
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.modalColor + "90"};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.selection};
    border-radius: 10px;
    border: 2px solid ${(props) => props.theme.colors.modalColor + "90"};
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${(props) => props.theme.colors.selectionDark};
    cursor: grab;
  }

  &::-webkit-scrollbar-thumb:active {
    cursor: grabbing;
  }
  &:hover {
    scrollbar-width: auto;
  }
  scrollbar-color: ${(props) => props.theme.colors.selection};
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sp-8);
  width: 100%;

  label {
    font-weight: 600;
    font-size: var(--fs-md);
    color: ${(props) => props.theme.colors.text};
    display: flex;
    align-items: center;
    gap: var(--sp-8);
  }

  input,
  select,
  textarea {
    box-sizing: border-box;
    width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--sp-12);
  margin-top: var(--sp-24);
  flex-wrap: wrap;
`;

export const Button = styled.button<{ color?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-12) var(--sp-24);
  border-radius: 8px;
  border: none;
  background-color: ${(props) => props.color || props.theme.colors.selection};
  color: ${(props) => props.theme.colors.textOnPrimary};
  font-weight: 600;
  font-size: var(--fs-md);
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s, opacity 0.2s;
  gap: var(--sp-8);

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    opacity: 0.9;
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const MaterialIcons = styled.span`
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: var(--fs-xl);
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const SecondaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-12) var(--sp-24);
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  cursor: pointer;
  font-size: var(--fs-md);
  font-weight: 500;
  transition: background-color 0.2s, transform 0.2s;
  gap: var(--sp-8);

  &:hover {
    background-color: #e8e8e8;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const SectionTitle = styled.h3`
  font-size: var(--fs-xl);
  font-weight: 600;
  color: ${(props) => props.theme.colors.selection};
  margin: 0 0 var(--sp-16) 0;
  text-shadow: -0.5px -0.5px 0.5px black, 0.5px -0.5px 0.5px black,
    -0.5px 0.5px 0.5px black, 0.5px 0.5px 0.5px black;
`;

// Exportação padrão para compatibilidade
export default {
  FieldsContainer,
  InputWrapper,
  ButtonWrapper,
  Button,
  MaterialIcons,
  SecondaryButton,
  SectionTitle,
};
